import { useEffect, useRef, useState } from 'react';

/** `true` enquanto a media query casa; acompanha mudanças (rotação, redimensionar). */
export function useMediaQuery(query: string): boolean {
  const [casa, setCasa] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const atualiza = () => setCasa(mql.matches);
    atualiza();
    mql.addEventListener('change', atualiza);
    return () => mql.removeEventListener('change', atualiza);
  }, [query]);
  return casa;
}

const COPIADO_MS = 3000;

/**
 * Cópia para a área de transferência no próprio clique (spec 31 R5 a R7). Com um texto que ainda
 * vai chegar, usa `ClipboardItem` com a promessa: Safari e Firefox recusam escrever depois de um
 * `await`. `copiado` é a chave do último item copiado, por 3 s; `manual` é o texto a mostrar num
 * campo para Ctrl+C quando a área de transferência recusa. Se a promessa do texto rejeitar, o erro
 * volta a quem chamou e não há `manual`.
 */
export function useCopiar() {
  const [copiado, setCopiado] = useState<string | null>(null);
  const [manual, setManual] = useState<{ chave: string; texto: string } | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  async function copiar(chave: string, texto: string | Promise<string>): Promise<boolean> {
    setManual(null);
    const area = navigator.clipboard;
    const prometido = Promise.resolve(texto);
    let escrita: Promise<void>;
    if (!area) escrita = Promise.reject(new Error('sem área de transferência'));
    else if (typeof texto === 'string') escrita = area.writeText(texto);
    else if (typeof ClipboardItem !== 'undefined')
      escrita = area.write([
        new ClipboardItem({
          'text/plain': prometido.then((t) => new Blob([t], { type: 'text/plain' })),
        }),
      ]);
    else escrita = prometido.then((t) => area.writeText(t));
    try {
      await escrita;
    } catch {
      setManual({ chave, texto: await prometido });
      return false;
    }
    clearTimeout(timer.current);
    setCopiado(chave);
    timer.current = setTimeout(() => setCopiado(null), COPIADO_MS);
    return true;
  }

  return { copiar, copiado, manual };
}
